<template>
  <div class="c-rsvp-config__form c-rsvp-edit-form">
    <form @submit.prevent="submit">
      <div class="columns is-multiline">
        <div class="field-body column is-full">
          <div class="field">
            <div
              class="control"
              autocomplete="off"
              :class="{ 'has-error': validation.hasError('page_title') }"
            >
              <BaseInputOutlined
                v-model="page_title"
                class="has-text-left"
                label="<strong>Título da página</strong>"
                :hasError="validation.hasError('page_title')"
                :error="
                  validation.hasError('page_title')
                    ? validation.firstError('page_title')
                    : ''
                "
                :maxlength="50"
              />
            </div>
          </div>
        </div>

        <div class="field-body column is-full">
          <div class="field">
            <div
              :class="{ 'has-error': validation.hasError('page_introduction') }"
              class="control"
              autocomplete="off"
            >
              <BaseTextareaOutlined
                v-model="page_introduction"
                class="has-text-left"
                label="<strong>Introdução (opcional)</strong>"
                :rows="2"
                :maxlength="800"
                :hasError="validation.hasError('page_introduction')"
                :error="
                  validation.hasError('page_introduction')
                    ? validation.firstError('page_introduction')
                    : ''
                "
              />
            </div>
          </div>
        </div>
      </div>

      <div class="c-rsvp-config__btn">
        <a
          v-if="rsvpSitePageUrl"
          :href="rsvpSitePageUrl"
          target="_blank"
          class="button is-outlined is-big is-gray"
        >
          Visualizar no site
        </a>

        <button
          :disabled="!formIsValidated || formLoading || !formIsTouched"
          :class="{
            'is-primary': formIsValidated && !formLoading,
            'is-loading': formLoading,
          }"
          type="submit"
          class="button is-big is-primary"
        >
          Salvar alterações
        </button>
      </div>

      <transition name="fade">
        <div class="notification is-light" :class="classAlert" v-if="msgAlert">
          <button class="delete" type="button" @click="closeAlert"></button>
          {{ msgSubmitAlert }}
        </div>
      </transition>
    </form>
  </div>
</template>

<script>
import RsvpApi from '@/lib/api/Rsvp'
import SimpleVueValidator from 'simple-vue-validator'

import BaseInputOutlined from '@/components/BaseInputOutlined.vue'
import BaseTextareaOutlined from '@/components/BaseTextareaOutlined.vue'

const Validator = SimpleVueValidator.Validator.create({
  templates: {
    required: 'Este campo não pode ficar vazio',
  },
})

export default {
  mixins: [SimpleVueValidator.mixin],

  components: {
    BaseInputOutlined,
    BaseTextareaOutlined,
  },

  validators: {
    page_title(value) {
      return Validator.value(value).maxLength(50).required()
    },

    page_introduction(value) {
      return Validator.value(value).maxLength(800)
    },
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    rsvpSitePageUrl() {
      return this.wedSiteInfo && this.wedSiteInfo.site_url_protocol
        ? `${this.wedSiteInfo.site_url_protocol}/#/rsvp`
        : ''
    },

    formIsValidated() {
      return !this.validation.hasError('page_title')
    },

    formIsTouched() {
      return (
        this.validation.isTouched('page_title') ||
        this.validation.isTouched('page_introduction')
      )
    },
  },

  data() {
    return {
      page_title: '',
      page_introduction: '',
      started: false,
      formLoading: false,
      msgSubmitAlert: '',
      msgAlert: false,
      classAlert: '',
    }
  },

  watch: {
    $route: 'fetchData',
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.started = true
      const rsvpApi = new RsvpApi(this.logonToken)
      rsvpApi.getConfigsRsvp().then((response) => {
        const data = response.data.data
        this.page_title = data.page_title
          ? data.page_title
          : 'Confirme sua presença'
        this.page_introduction = data.page_introduction
        this.validation.reset()
      })
    },

    submit() {
      this.formLoading = true
      this.$validate().then((success) => {
        if (success) this.setRsvpConfigs()
      })
    },

    setRsvpConfigs() {
      const rsvpApi = new RsvpApi(this.logonToken)
      const data = {
        partner: true,
        wed_id: this.logonToken.token_payload.wed_id,
        page_title: this.page_title,
        page_introduction: this.page_introduction,
      }

      rsvpApi
        .setConfigRsvp(data)
        .then((response) => {
          if (response.status === 201) {
            this.msgAlert = true
            this.classAlert = 'is-dark'
            this.msgSubmitAlert = 'As alterações foram salvas com sucesso.'
          }
        })
        .catch(() => {
          this.msgAlert = true
          this.classAlert = 'is-error'
          this.msgSubmitAlert = 'Erro ao enviar configuração'
        })
        .finally(() => {
          setTimeout(() => {
            this.formLoading = false
            this.validation.reset()
          }, 1000)
          setTimeout(() => {
            this.closeAlert()
          }, 5000)
        })
    },

    closeAlert() {
      this.msgAlert = false
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/bit-assets/vendors/bulma/material-form';

.c-rsvp-edit-form {
  margin-top: 50px;
}

.c-rsvp-config {
  &__form {
    .label {
      font-size: 16px !important;
      top: -32px !important;
      color: #686868;
      line-height: 1.14;
      font-weight: bold;
    }

    .field-body {
      margin-bottom: 16px;

      @media (min-width: $tablet) {
        margin-top: 10px;
      }

      &.margin-bottom {
        margin-bottom: 0;
      }
    }
  }

  &__btn {
    text-align: center;
    margin-top: 30px;

    @media (min-width: $tablet) {
      text-align: right;
      margin-top: 40px;
    }

    button,
    a {
      width: 100%;
      margin: 0;
      margin-bottom: 20px;

      @media (min-width: $tablet) {
        width: auto;
        margin-left: 15px;
      }
    }
  }

  .notification {
    @include position(fixed, auto, 0, 2em, 0);
    padding: 1rem 2.5rem 1rem 1.5rem;
    margin: 15px auto 0;
    max-width: 350px;
    z-index: 10;

    > .delete {
      @include position(absolute, 50%, 0.5rem, auto, auto, -50%);
    }
  }
}
</style>
